<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="14.376"
      viewBox="0 0 14.376 14.376"
      class="scaling-svg"
    >
      <path
        d="M11.98,14.376H2.4A2.4,2.4,0,0,1,0,11.98V2.4A2.4,2.4,0,0,1,2.4,0H11.98a2.4,2.4,0,0,1,2.4,2.4V11.98A2.4,2.4,0,0,1,11.98,14.376ZM2.4,1.6a.8.8,0,0,0-.8.8V11.98a.8.8,0,0,0,.8.8H11.98a.8.8,0,0,0,.8-.8V2.4a.8.8,0,0,0-.8-.8ZM8.785,9.584a.793.793,0,0,1-.564-.234L7.188,8.317,6.155,9.35A.8.8,0,0,1,5.026,8.221L6.059,7.188,5.026,6.155A.8.8,0,1,1,6.155,5.026L7.188,6.059,8.221,5.026A.8.8,0,0,1,9.35,6.155L8.317,7.188,9.35,8.221a.8.8,0,0,1-.565,1.363Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CancelIcon extends Vue {}
</script>

<style>
</style>
